var render = function render(){var _vm=this,_c=_vm._self._c;return _c('SetPermissionsPage',{attrs:{"permissions":_vm.permissions,"pageTitle":_vm.$t('users.userPermissions'),"settablePermissions":_vm.companyPermissions,"detailPageName":'CompanyUserDetailPage'}})
}
var staticRenderFns = []

export { render, staticRenderFns }